import { FC } from 'react';
import { Modal } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

import { ContactForm } from '../ContactForm';

interface IModal {
  isOpen: boolean;
  isSubmitting: boolean;
  onSubmit: (data) => void;
  onCancel: () => void;
}

export const NewContactModal: FC<IModal> = ({ isOpen, onSubmit, onCancel, isSubmitting }) => {
  return (
    <Modal open={isOpen} data-testid="new-contact-modal">
      <Modal.Title>Add New Contact</Modal.Title>
      <Modal.Content>
        <ContactForm onSubmit={onSubmit} onCancel={onCancel} />
      </Modal.Content>
      <Modal.Actions>
        <Button color="tertiary" onClick={onCancel} loading={isSubmitting}>
          Cancel
        </Button>
        <Button color="primary" type="submit" form={'contact'} loading={isSubmitting}>
          {isSubmitting ? 'Saving...' : 'Save'}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
